// Other
import { Ref } from 'vue';
import { $error } from '@/utils/app-utils';
import AuthorizationProvider from '@/core/Authorization/AuthorizationProvider';
import Operations from '@/core/Authorization/Operations';
import NumericCounterValueService from '@/core/Services/NumericCounterValueService';
import INumericCounterValue from '@/core/Models/INumericCounterValue';

const api = {
    async createAsync(numericCounter: INumericCounterValue): Promise<INumericCounterValue | undefined> {
        try {
            return await NumericCounterValueService.createAsync(
                {
                    counterId: numericCounter.counterId,
                    value: numericCounter.value,
                    tagName: numericCounter.tagName,
                    tagValue: numericCounter.tagValue,
                    date: numericCounter.date,
                },
                'default',
            );
        } catch (error) {
            $error(error);
        }
    },

    async bulkInsertAsync(numericCounters: INumericCounterValue[]): Promise<INumericCounterValue[] | undefined> {
        try {
            return await NumericCounterValueService.bulkInsertAsync(
                numericCounters.map((numericCounter) => ({
                    counterId: numericCounter.counterId,
                    value: numericCounter.value,
                    tagName: numericCounter.tagName,
                    tagValue: numericCounter.tagValue,
                    date: numericCounter.date,
                })),
                'default',
            );
        } catch (error) {
            $error(error);
        }
    },
};

export function useNumericCounterValueApi() {
    return api;
}

export function useNumericCounterValuePermissions(numericCounterValue: Ref<INumericCounterValue>) {
    const canRead = AuthorizationProvider.authorize(numericCounterValue.value, Operations.NumericCounterValues.Read);
    const canCreate = AuthorizationProvider.authorize(
        numericCounterValue.value,
        Operations.NumericCounterValues.Create,
    );

    return {
        canRead,
        canCreate,
    };
}
